import { IV2GetMessages } from '../../repositories/cian-chat-bot/entities/get_messages_response/V2GetMessages';
import { TGetMessagesResponse, fetchGetMessages } from '../../repositories/cian-chat-bot/v2/get-messages';
import { IChatbotMessageSchema } from '../../types/chatbot';
import { TContext } from '../../types/context';
import { TMessageSchema } from '../../types/messages';
import { mapChatbotMessageToChatMessage } from '../../utils/mapChatbotMessageToChatMessage';

export type IGetMessagesResponse = IV2GetMessages;

const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotMessages';

export async function fetchChatbotMessages(
  { httpApi, logger, telemetry }: TContext,
  rowVersion: number,
): Promise<(Omit<IGetMessagesResponse, 'messages'> & { messages: TMessageSchema[] }) | null> {
  try {
    const { statusCode, response }: TGetMessagesResponse = await fetchGetMessages({
      httpApi,
      parameters: {
        rowVersion,
        excludeDeleted: true,
      },
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning('Невалидный ответ от сервера', {
        domain: 'src/shared/services/fetchChatbotMessages.ts',
        statusCode,
        messsage: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });

      return null;
    }

    return {
      ...response,
      messages: response.messages.map((message: IChatbotMessageSchema, index: number) =>
        mapChatbotMessageToChatMessage(message, index, response.unreadMessagesCount),
      ),
    };
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      message: 'Не удалось получить сообщения чатбота',
      domain: 'src/shared/services/fetchChatbotMessages.ts',
    });

    return null;
  }
}
